import { useGetAllUnreadChatMessages } from '@commenda/api';
import { FeaturedIcon, Icons, LoadingIndicator } from '@commenda/kakashi';
import { IUnreadChatRoomMessage, UserTypes } from '@commenda/types/src/chat-room/types';
import { ChatRoomModel } from '@commenda/utils';
import { useEffect, useState } from 'react';
import { ThreadsChatMessage } from './ThreadsChatMessage';

export const ChatRoomRecentMessages = ({
  userType,
  corporationId,
  caFirmId,
}: {
  userType: UserTypes;
  corporationId?: number;
  caFirmId?: string;
}) => {
  const {
    data,
    error,
    mutate: getUnreadMessagesMutate,
  } = useGetAllUnreadChatMessages({
    userType: UserTypes.ACCOUNTANT,
    caFirmId,
  });
  const [unreadMessages, setUnreadMessages] = useState<
    IUnreadChatRoomMessage[]
  >([]);

  useEffect(() => {
    setUnreadMessages(ChatRoomModel.parseUnreadMessages(data));
  }, [data]);

  const filteredMessages = (
    corporationId
      ? unreadMessages?.filter((message) => message.corporationId === corporationId)
      : unreadMessages
  )?.filter(ChatRoomModel.isValidForDisplay);

  if (!data) {
    if (error) console.error(error);

    return (
      <div className="flex flex-col gap-2 py-5 px-3">
        <h2 className="text-text-quaternary txt-small-medium py-1.5 px-2">
          Threads
        </h2>
        <div className="flex flex-col h-[252px] justify-center items-center gap-3">
          <LoadingIndicator size={64} />
        </div>
      </div>
    );
  }

  if (filteredMessages?.length === 0)
    return (
      <div className="flex flex-col gap-2 py-5 px-3">
        <h2 className="text-text-quaternary txt-small-medium py-1.5 px-2">
          Threads
        </h2>
        <div className="flex flex-col h-[252px] justify-center items-center gap-3">
          <FeaturedIcon
            icon={<Icons.MessageSquare02 />}
            variant="gray-modern"
          />
          <div className="flex flex-col gap-1 items-center px-4">
            <h3 className="txt-small-medium text-text-primary">
              No new Threads.
            </h3>
          </div>
        </div>
      </div>
    );

  return (
    <div className="grow overflow-y-auto">
      <div className="flex flex-col gap-2 py-5 px-3">
        <h2 className="text-text-quaternary txt-small-medium py-1.5 px-2">
          Threads
        </h2>
        <div className="flex flex-col">
          {filteredMessages?.map((message) => (
            <ThreadsChatMessage
              key={message.messageId}
              message={message}
              getUnreadMessagesMutate={getUnreadMessagesMutate}
              userType={userType}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
